import React, { useState } from "react";

/**
 * Subtle, dismissible banner explaining why the pacer was auto-tuned.
 * Renders only when `decision` is provided (i.e. preSuds was non-null).
 */
export default function AdaptivePacerBanner({ decision, preSuds }) {
  const [open, setOpen] = useState(true);
  if (!decision || !open) return null;

  const toneColor =
    decision.bandTone === "high"
      ? "var(--accent-red)"
      : decision.bandTone === "moderate"
      ? "var(--accent-blue)"
      : "var(--ink-mute)";
  const bg =
    decision.bandTone === "high"
      ? "var(--accent-red-soft)"
      : decision.bandTone === "moderate"
      ? "var(--accent-blue-soft)"
      : "var(--bg-soft)";

  return (
    <div
      className="rounded-2xl px-5 py-3 flex items-center gap-3"
      style={{
        background: bg,
        border: `1px solid ${toneColor}33`,
      }}
      data-testid="adaptive-pacer-banner"
    >
      <span
        className="w-2 h-2 rounded-full flex-shrink-0"
        style={{
          background: toneColor,
          boxShadow: `0 0 10px ${toneColor}66`,
        }}
      />
      <div className="flex-1 leading-snug">
        <div
          className="text-[10px] tracking-[0.24em] uppercase font-bold"
          style={{ color: toneColor }}
        >
          Auto-tuned · Pre-SUDS {preSuds}
        </div>
        <div className="text-sm text-ink mt-0.5">
          Pacer set to <span className="font-mono font-bold">{decision.pattern}</span>{" "}
          — <span className="text-mute">{decision.label}.</span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="text-[10px] tracking-[0.20em] uppercase font-semibold text-mute hover:text-ink transition-colors"
        data-testid="adaptive-pacer-dismiss"
        aria-label="Dismiss adaptive pacer hint"
      >
        Dismiss
      </button>
    </div>
  );
}
